import { useDispatch } from "react-redux";
import {
  trackLCAddToCartAction,
  trackLCSaveConfiguationAction,
  trackLCSimpleButtonAction,
} from "~/features/configurator/Linear/redux/gaActions";
import type { PushContextValues } from "~/features/configurator/common/configuratorGA";

export const useTrackLCAddToCartClick = () => {
  const dispatch = useDispatch();

  return () => dispatch(trackLCAddToCartAction());
};

export const useTrackLCSaveConfigurationClick = () => {
  const dispatch = useDispatch();

  return () => dispatch(trackLCSaveConfiguationAction());
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTrackLCSimpleButtonClick = (pushContext: PushContextValues, extra?: Dict<any>) => {
  const dispatch = useDispatch();
  return () => dispatch(trackLCSimpleButtonAction(pushContext, extra));
};
